import { QueryFactory } from "../../../../Common";
import { Casino } from "../../../../Contracts";
export const QGetLaunchParams = QueryFactory(Casino.QueryTypes.GetLaunchParams);
//# sourceMappingURL=QGetLaunchParams.js.map